import {
    ChangeDetectionStrategy,
    Component,
    inject,
} from '@angular/core';

import {
    MatProgressBarModule,
} from '@angular/material/progress-bar';

import {
    MatProgressSpinnerModule,
} from '@angular/material/progress-spinner';

import {
    TranslateModule,
} from '@ngx-translate/core';

import {
    AppLoaderService,
} from 'src/app/core/services/app-loader.service';

/**
 * The full screen loader of the application, driven by `AppLoaderService`. It covers the whole window (`.back-loader`)
 * and is hidden while the service is not enabled.
 */
@Component({
    standalone: true,
    imports: [
        MatProgressBarModule,
        MatProgressSpinnerModule,
        TranslateModule,
    ],
    selector: 'app-loader',
    templateUrl: './app-loader.component.html',
    styleUrls: ['./app-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'back-loader',
        '[style.display]': "loader.enabled() ? 'block' : 'none'",
    },
})
export class AppLoaderComponent {
    protected readonly loader = inject(AppLoaderService);
}
